export class DadosAcessoCidadao {
    public CpfBase: number;
    public CpfDigito: number;
    public NomeMae: string; 
    public DataNascimento: string;
    public Senha: string;
    public ConfirmacaoSenha: string;   
  }


// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/shared/dados-acesso-cidadao.ts